module.exports = __webpack_public_path__ + "img/ssyx_39.9b7ea576.jpg";